import React from 'react';
import useDropArea from '../../hooks/use-dnd/use-drop-area';
import { DRAG_TYPE, DropCallback } from '../../stores/reducers/user-interface';

/* we render this when a overlay item is being dragged, it functions as a drop area
on top of the canvas that accepts overlay items */

interface Props {
	dropCallback: DropCallback
}

export default function TitleDropArea(props: Props) {
	const { dropRef } = useDropArea({
		accepts: DRAG_TYPE.TITLE,
		dropCallback: props.dropCallback,
		dropAreaData: {
			id: 'title-drop-area',
		},
	});

	return (
		<div
			className="overlay-drop-area"
			id="title-drop-area"
			ref={dropRef}
		/>
	);
}
